import { createReducer } from "@reduxjs/toolkit";

const initialState = {
 loading : false ,
 Jobs : null,
};

export const jobsReducer = createReducer(initialState,{

    fetchJobsRequest : (state) => {
        state.loading = true;
    },

    fetchJobsSuccess : (state, action) => {
        state.loading = false;
        state.Jobs = action.payload;
    },

    fetchJobsFailure : (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },
    
});